module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "partner-notice"
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    on: {
      "change": _vm.collapseChange
    }
  }, [_vm._l((_vm.notifyAllData), function(item) {
    return _c('el-collapse-item', {
      key: item.id,
      attrs: {
        "name": item.id
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      staticClass: "item-title",
      class: {
        read: !item.read
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "item-date"
    }, [_vm._v(_vm._s(item.date))])]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })], 2)
  }), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b8fd613","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/partnerNotice/index.vue
// module id = 948
// module chunks = 1